import { Component, inject, model } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    styleUrls: ['./confirm-modal.component.scss'],
  imports: [
    MatDialogContent,
    MatDialogActions,
    MatDialogTitle,
    MatButton,
    MatIcon,
  ],
})
export class ConfirmModalComponent {
  readonly dialogRef = inject(MatDialogRef<ConfirmModalComponent>);
  readonly data = inject(MAT_DIALOG_DATA);
  readonly title = model(this.data.title);
  readonly body = model(this.data.body);
}
